import React from "react";
import { Select } from "antd";
import { CountriesJSON } from "../countriesJSON";

const CountrySelectInput = ({ label, onChange, value, name, id, error, className, disabled = false, placeholder = "Select an option", required }) => {
  const countryOptions = React.useMemo(() =>
    CountriesJSON?.map((country) => ({
      value: country.Country,
      label: country.Country,
    })),
    []
  );

  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="block text-sm font-normal text-gray-500">
        {label}
        {required && <span className="text-red-500"> *</span>}
      </label>
      <Select
        className={className}
        placeholder={placeholder}
        onChange={(value) => onChange({ target: { value, name } })}
        value={value}
        name={name}
        id={id}
        options={countryOptions}
        showSearch
        filterOption={(input, option) =>
          option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        aria-label={label}
        disabled={disabled} // Pass disabled prop to make it read-only
      />
      {error && <span className="text-sm text-red-500" role="alert">{error}</span>}
    </div>
  );
};

export default React.memo(CountrySelectInput);